if(!customElements.get('sticky-add-to-cart')) {
    class StickyAddToCart extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                target: document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart'),
                qtyInput: document.querySelector('.QuantitySelector__CurrentQuantity'),
                button: this.querySelector('.sticky-add-to-cart button')
            }
            window.addEventListener('scroll',() => {
                const rect = this.selectors.target.getBoundingClientRect();
                const targetHeight = this.selectors.target.offsetHeight;
                const isVisible = rect.top >= 0 && rect.bottom <= window.innerWidth;
                if(!isVisible && rect.bottom <= (targetHeight + 100)) {
                    document.body.classList.add('sticky-add-to-cart');
                } else {
                    document.body.classList.remove('sticky-add-to-cart');
                }
            })
            this.selectors.button.addEventListener('click', event => {
                this._addedToCart(event.target.closest('button'), event.target.closest('button').dataset.variantId, this.selectors.qtyInput ? parseInt(this.selectors.qtyInput.value) : 1);
            }) 
        }
        async _addedToCart(target, variantId, quantity) {
            target.classList.add('active');
            const cartEndpoint = '/cart/add.js';
            const data = {
                items: [
                    {
                        id: variantId,
                        quantity: quantity
                    }
                ]
            };

            try {
                const response = await fetch(cartEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                if (response.ok) {
                    console.log(target);
                    target.classList.remove('active');
                    const cartDrawer = document.querySelector('.Header__Icon[href="/cart"]');
                    cartDrawer && cartDrawer.click();
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'quick_add_product_click',
                        event_category: 'Product Page',
                        event_label: target.dataset.productName,
                        product_id: target.dataset.productId,
                        device_type: window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop'
                    });
                } else {
                    console.error('Failed to add item to cart:', response.statusText);
                }
            } catch (error) {
                console.error('Error adding item to cart:', error);
            }
        }
    }
    customElements.define('sticky-add-to-cart', StickyAddToCart);
}